module.exports = __webpack_public_path__ + "static/media/Dell UltraSharp 24\" 90deg.63158237.png";